import {
  ButtonSection,
  Head,
  Img,
  ImgSection,
  ButtonSectionDownload,
  TextDescription,
  TextHeading,
  TextHeadingBlue,
  TextSection,
  ImgDownload,
} from "./styledHeader";
import { HeaderMAin } from "../../../../images";
import { MuiButton } from "../../../../Components/Form";
import { useModalContext } from "../../../../Provider/ModalProvider";
import { Fade, Zoom } from "react-reveal";
import { useSelector } from "react-redux";
import { GET_REQUEST } from "~/HooksApi/useApi";
import UseGetData from "~/HookAxios/getdata";
import { Skeleton, Typography } from "@mui/material";
import Parser from "html-react-parser";
import * as Images from "../../../../images";
const Header = () => {
  const { openRigester } = useModalContext();
  const token = useSelector((state) => state.Auth.userInfo.token);
  const { isLoading: loading, data: data } = GET_REQUEST({
    queryKey: "getHero",
    request: () => UseGetData("get_hero_section"),
    enabled: true,
  });
  return (
    <>
      <Head>
        <TextSection>
          {!loading && Parser(data?.data?.data?.hero_section.title)}

          {/* <TextHeading>
          تعلم عن بعد
        </TextHeading>
        <TextDescription>
          منصة طالب التعليمية أسلوب متفرد في تقنيات التعلم عن بعد بالاعتماد على الوسائل التعليمية الحديثة والتفاعلية من خلال  اكفاء المدرسين والمدربين        </TextDescription> */}
          <ButtonSection>
            <Zoom>
              {!token && (
                <MuiButton
                  text=" سجّل معنا "
                  width="100%"
                  height="40px"
                  onClick={openRigester}
                />
              )}
            </Zoom>
          </ButtonSection>
        </TextSection>
        <ImgSection>
          {loading ? (
            <Skeleton width="28vw" height="400px" />
          ) : (
            <Fade>
              <Img
                src={`${process.env.REACT_APP_BASE_URL}${data?.data?.data?.hero_section?.image_path}`}
                alt="header"
              />
            </Fade>
          )}
        </ImgSection>
      </Head>

      <ButtonSectionDownload>
        <div>
          <Typography sx={{ width: "100%", mb: "12px" }} textAlign={"center"}>
            انتظرونا قريبا على Apple Store
          </Typography>
          <div>
            <ImgDownload
              src={Images.GooglePlay}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.location.assign(
                  "https://play.google.com/store/apps/details?id=com.perla.taleb"
                )
              }
            />
            <ImgDownload src={Images.AppStore} alt="" />
          </div>
        </div>
      </ButtonSectionDownload>
    </>
  );
};

export default Header;
